import { render, staticRenderFns } from "./ButtonWidgetPanel.vue?vue&type=template&id=6e1df0cb&scoped=true"
import script from "./ButtonWidgetPanel.vue?vue&type=script&lang=js"
export * from "./ButtonWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./ButtonWidgetPanel.vue?vue&type=style&index=0&id=6e1df0cb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1df0cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e1df0cb')) {
      api.createRecord('6e1df0cb', component.options)
    } else {
      api.reload('6e1df0cb', component.options)
    }
    module.hot.accept("./ButtonWidgetPanel.vue?vue&type=template&id=6e1df0cb&scoped=true", function () {
      api.rerender('6e1df0cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/settingPanel/ButtonWidgetPanel.vue"
export default component.exports